import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { createCupom, getCupom, setCupom } from "../../../../services/modules/cliente/clienteService";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import { coinsListTravel, ReturnName } from "../../../../utils/coins";
import { AlertNotify } from "../../../alerts/AlertNotify";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalCupomAdmin(props: {
  cupom: any;
  onClose?: () => void;
}) {
  const { cupom, onClose } = props;
  const [open, setOpen] = React.useState(false);
  const [descricao, setDescricao] = React.useState("");
  const [valorMinimo, setValorMinimo] = React.useState("");
  const [valorDesconto, setValorDesconto] = React.useState("");
  const [codigoCupom, setCodigoCupom] = React.useState("");
  const [dataFim, setDataFim] = React.useState("");
  const [dataInicio, setDataInicio] = React.useState("");
  const [moedasSelecionadas, setMoedasSelecionadas] = React.useState([]);
  const isEditing = !!cupom?.codigo_cupom;


  const handleChange = (event) => {
    const { name, checked } = event.target;
    setMoedasSelecionadas((prev) =>
      checked ? [...prev, name] : prev.filter((cod) => cod !== name)
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const handleSave = () => {
    const coins = coinsListTravel.map((moeda) => ({
      ...moeda,
      selecionado: moedasSelecionadas.includes(moeda.codMoeda),
    }));

    const novoCupom = {
      codigo_cupom: codigoCupom,
      descricao: descricao,
      valor_minimo_compra: valorMinimo,
      valor_desconto: valorDesconto,
      data_inicio_validade: new Date(dataInicio),
      data_fim_validade: new Date(dataFim),
      listaMoedas: coins,
      informacoes_validade: ""
    };

    const apiCall = isEditing ? setCupom : createCupom;
    apiCall(novoCupom)
    .then(() => {
      AlertNotify({
        message: isEditing
          ? "Cupom atualizado com sucesso!"
          : "Cupom cadastrado com sucesso!",
      });
      handleClose();
    })
    .catch((err) => {
      AlertNotify({
        message: `Erro ao ${isEditing ? "atualizar" : "cadastrar"} cupom: ${err}`,
        type: "danger",
      });
    });
  };

  React.useEffect(() => {
    if (cupom?.codigo_cupom)  {
      handleClickOpen();
      getCupom(cupom.codigo_cupom)
        .then(({ data }) => {
          if (data) {
            setCodigoCupom(data.codigo_cupom);
            setDescricao(data.descricao);
            setValorMinimo(data.valor_minimo_compra);
            setValorDesconto(data.valor_desconto);
            setDataInicio(
              data.data_inicio_validade
                ? new Date(data.data_inicio_validade).toISOString().slice(0, 10)
                : ""
            );
            setDataFim(
              data.data_fim_validade
                ? new Date(data.data_fim_validade).toISOString().slice(0, 10)
                : ""
            );
            setMoedasSelecionadas(
              data.listaMoedas
                .filter((m) => m.selecionado)
                .map((m) => m.codMoeda)
            );
          }
        })
        .catch((err) => {
          console.error("Erro ao buscar cupom:", err);
        });
    }else {
      handleClickOpen();
    }
  }, [cupom]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Cupom de Desconto</DialogTitle>
        <DialogContent
          style={{
            paddingTop: "10px",
            gap: 10,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={StyleContent}>
            <FormControl variant="outlined">
              <InputLabel htmlFor="codigo-cupom"
                required>Código do Cupom</InputLabel>
              <OutlinedInput
                id="codigo-cupom"
                value={codigoCupom}
                onChange={(e) => setCodigoCupom(e.target.value)}
                label="Código do Cupom"
                disabled={isEditing}
                required
              />
            </FormControl>

            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="descricao"
                required>Descrição</InputLabel>
              <OutlinedInput
                id="descricao"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                label="Descrição"
              />
            </FormControl>
          </div>
          <div style={StyleContent}>
            <FormControl fullWidth>
              <InputLabel htmlFor="outlined-adornment-amount"
                required>
                Valor Mínimo da Compra
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                startAdornment={
                  <InputAdornment position="start">R$</InputAdornment>
                }
                label="Valor Mínimo da Compra"
                value={valorMinimo}
                onChange={(e) => setValorMinimo(e.target.value)}
                required
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel htmlFor="outlined-adornment-amount"
                required>
                Valor do Desconto
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                startAdornment={
                  <InputAdornment position="start">R$</InputAdornment>
                }
                label="Valor do Desconto"
                value={valorDesconto}
                onChange={(e) => setValorDesconto(e.target.value)}
                required
              />
            </FormControl>
          </div>
          <div style={StyleContent}>
            <FormControl fullWidth>
              <TextField
                id="data"
                label="Data"
                type="date"
                fullWidth
                variant="outlined"
                value={dataInicio}
                onChange={(e) => setDataInicio(e.target.value)}
                InputLabelProps={{
                  shrink: true, // Isso faz o label ficar visível fora do campo mesmo com valor
                }}
                required
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                id="data-fim"
                label="Data Fim"
                type="date"
                fullWidth
                variant="outlined"
                value={dataFim}
                onChange={(e) => setDataFim(e.target.value)}
                InputLabelProps={{
                  shrink: true, // Isso faz o label ficar visível fora do campo mesmo com valor
                }}
                required
              />
            </FormControl>
          </div>
          <div>
            <FormControl component="fieldset" variant="standard">
              <FormLabel component="legend">Selecione as Moedas</FormLabel>
              <FormGroup
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 1, // espaçamento entre itens
                }}
              >
                {coinsListTravel.map((moeda) => (
                  <FormControlLabel
                    key={moeda.codMoeda}
                    control={
                      <Checkbox
                        checked={moedasSelecionadas.includes(moeda.codMoeda)}
                        onChange={handleChange}
                        name={moeda.codMoeda}
                      />
                    }
                    label={ReturnName(moeda.codMoeda) ?? moeda.nome }
                  />
                ))}
              </FormGroup>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSave}>Salvar</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const StyleContent: React.CSSProperties = {
  paddingTop: "10px",
  display: "flex",
  gap: 10,
};
